const ARABIC_INDIC = '٠١٢٣٤٥٦٧٨٩';
const SEPARATORS = new Set([' ', '-', '(', ')']);
const STRIP_CHARS = new Set(['‎', '‏', '؜', ' ']);

/**
 * The same rules as functions/phone.js, restated for the browser. This copy
 * exists to keep the submit button honest before a round trip; the server copy
 * is the one that decides.
 */
export function normalizePhoneInput(input: string): string | null {
  if (typeof input !== 'string') return null;
  let s = '';
  for (const ch of input.trim()) {
    const idx = ARABIC_INDIC.indexOf(ch);
    if (idx !== -1) { s += String(idx); continue; }
    if (ch >= '0' && ch <= '9') { s += ch; continue; }
    if (ch === '+') { s += ch; continue; }
    if (SEPARATORS.has(ch) || STRIP_CHARS.has(ch)) continue;
    return null;
  }
  if (s.startsWith('+966')) s = '0' + s.slice(4);
  else if (s.startsWith('966')) s = '0' + s.slice(3);
  return /^05\d{8}$/.test(s) ? s : null;
}
